const PdfIcon = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.6105 7.89856L15.3603 0.774261C14.6382 0.150589 13.5 0.656886 13.5 1.6257V5.37818C5.97052 5.46439 0 6.97343 0 14.109C0 16.9891 1.85536 19.8423 3.90623 21.334C4.54622 21.7995 5.45831 21.2152 5.22234 20.4606C3.09684 13.6632 6.23049 11.8586 13.5 11.754V15.875C13.5 16.8453 14.6391 17.3494 15.3603 16.7264L23.6105 9.60143C24.1295 9.15321 24.1302 8.34739 23.6105 7.89856Z"
      fill="white"
    />
  </svg>
);

export default PdfIcon;
